module.exports = __webpack_public_path__ + "img/facebook.c679773f.png";